/* eslint-disable no-bitwise */

const palette = [
    'red',
    'pink',
    'grape',
    'violet',
    'indigo',
    'blue',
    'cyan',
    'teal',
    'green',
    'lime',
    'yellow',
    'orange',
];
const paletteLength = palette.length;

export const mantineColorHexCodes: Record<string, string> = {
    red: '#FA5252',
    pink: '#E64980',
    grape: '#BE4BDB',
    violet: '#7950F2',
    indigo: '#4C6EF5',
    blue: '#228BE6',
    cyan: '#15AABF',
    teal: '#12B886',
    green: '#40C057',
    lime: '#82C91E',
    yellow: '#FAB005',
    orange: '#FD7E14',
};

const getNumberFromUuid = (uuid: string) => {
    const hash = uuid.split('').reduce((acc, char) => {
        // eslint-disable-next-line no-param-reassign
        acc = (acc << 5) - acc + char.charCodeAt(0);
        return acc && acc;
    }, 0);

    return (Math.abs(hash) % paletteLength) + 1;
};

const getColorByUuid = (uuid: string): string => {
    const colorIndex = getNumberFromUuid(uuid);
    return palette[colorIndex - 1];
};

export default getColorByUuid;
